<div class="chart-line"><fpui-echarts :options="options"></fpui-echarts></div>